import { render, staticRenderFns } from "./DarkNavLink.vue?vue&type=template&id=4d2afa21&scoped=true&"
import script from "./DarkNavLink.vue?vue&type=script&lang=js&"
export * from "./DarkNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2afa21",
  null
  
)

export default component.exports